import React from 'react';

import { useDispatch } from 'react-redux';

import Avatar from 'common-ui/chat/Avatar';
import EmailMessage from 'common-ui/chat/EmailMessage';
import { formatDateTime } from 'utils/dateUtils';

import {
  ChatSingleItemLeft,
  ChatSingleItemLeftContent,
  ChatSingleItemLeftMessage,
  ChatSingleItemLeftMessageText,
  ChatSingleItemLeftName,
  ChatSingleItemLeftTime,
  ChatSingleItemLeftTimeBlock,
  ChatSingleItemLeftTimeStatusNew,
} from '../ChatSingle.styles';
import AttachmentRenderer from './AttachmentRenderer';
import AttachmentWrapper from './AttachmentWrapper';

const getSenderName = (sender) => {
  if (sender?.name && sender?.surname) {
    return `${sender.name} ${sender.surname}`;
  }
  if (sender?.name) {
    return sender.name;
  }
  return `User ${sender?.id?.slice(-6) || 'Unknown'}`;
};

const getMessageSenderName = (message, conversationSender = null) => {
  if (conversationSender) {
    return getSenderName(conversationSender);
  }
  if (message.sender) {
    return getSenderName(message.sender);
  }
  return 'Unknown User';
};

const isMediaTypeIndicator = (text) => {
  if (!text) return false;
  const trimmed = text.trim();
  return /^\[(Audio|Video|Image|Sticker|Document|File|Photo|Contact shared)\]$/i.test(trimmed);
};

const shouldDisplayMessageText = (messageText, hasAttachments) => {
  if (!messageText) return false;
  if (!hasAttachments) return true;
  return !isMediaTypeIndicator(messageText);
};

const ChatSingleItemLeftComponent = ({ message, conversation, platform }) => {
  const dispatch = useDispatch();

  const senderName = getMessageSenderName(message, conversation?.sender);

  if (message.platform === 'imap') {
    return (
      <ChatSingleItemLeft key={message._id}>
        <Avatar
          name={senderName}
          src={conversation?.sender?.avatar}
          platform="imap"
          size={32}
        />
        <ChatSingleItemLeftContent>
          <ChatSingleItemLeftName>{senderName}</ChatSingleItemLeftName>
          <EmailMessage message={message} isMyMessage={false} />
          <ChatSingleItemLeftTimeBlock>
            <ChatSingleItemLeftTime>
              {formatDateTime(
                message.timestamp || message.createdAt,
                false,
                false,
                'MMM D h:mm A'
              )}
            </ChatSingleItemLeftTime>
            {!message.isRead && (
              <ChatSingleItemLeftTimeStatusNew>NEW</ChatSingleItemLeftTimeStatusNew>
            )}
          </ChatSingleItemLeftTimeBlock>
        </ChatSingleItemLeftContent>
      </ChatSingleItemLeft>
    );
  }

  return (
    <ChatSingleItemLeft key={message._id}>
      <Avatar
        name={senderName}
        src={conversation?.sender?.avatar}
        platform={platform || 'facebook'}
        size={32}
      />
      <ChatSingleItemLeftContent>
        <ChatSingleItemLeftName>{senderName}</ChatSingleItemLeftName>
        <ChatSingleItemLeftMessage>
          {shouldDisplayMessageText(
            message.messageText,
            message.attachments && message.attachments.length > 0
          ) && (
            <ChatSingleItemLeftMessageText className={!message.isRead ? 'status-new' : ''}>
              {message.messageText}
            </ChatSingleItemLeftMessageText>
          )}
          {message.attachments && message.attachments.length > 0 && (
            <AttachmentWrapper $isMyMessage={false}>
              <AttachmentRenderer
                attachments={message.attachments}
                isMyMessage={false}
                platform={platform}
                message={message}
                dispatch={dispatch}
              />
            </AttachmentWrapper>
          )}
        </ChatSingleItemLeftMessage>
        <ChatSingleItemLeftTimeBlock>
          <ChatSingleItemLeftTime>
            {formatDateTime(
              message.timestamp || message.createdAt,
              false,
              false,
              'MMM D h:mm A'
            )}
          </ChatSingleItemLeftTime>
          {!message.isRead && (
            <ChatSingleItemLeftTimeStatusNew>NEW</ChatSingleItemLeftTimeStatusNew>
          )}
        </ChatSingleItemLeftTimeBlock>
      </ChatSingleItemLeftContent>
    </ChatSingleItemLeft>
  );
};

export default ChatSingleItemLeftComponent;
